import React from 'react'

import { useHistory } from 'react-router-dom'

import {
  Typography,
  makeStyles,
  useTheme,
  useMediaQuery,
} from '@material-ui/core'

import { routes } from 'routes'
import { NextButton, SafeEnvironment } from 'components'
import useSubscribe from 'hooks/useSubscribe'
import helpers from 'helpers'
import styles from './styles'

const useStyles = makeStyles(styles)

const Bottombar = () => {
  const classes = useStyles()
  const history = useHistory()
  const theme = useTheme()
  const subscribe = useSubscribe()

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const totalCart = React.useMemo(
    () => helpers.currency(subscribe.totalCart, { hideSymbol: true }),
    [subscribe.totalCart],
  )

  const handleClickNextButton = () => {
    history.push(routes.subscribe.checkout)
  }

  if (!isDesktop) {
    return (
      <div className={classes.mobile}>
        {!subscribe.sizeCart ? (
          <Typography className={classes.empty}>
            Você ainda não possui planos no carrinho
          </Typography>
        ) : (
          <NextButton
            size="large"
            onClick={handleClickNextButton}
            noBorderRadius
            fullWidth
          >
            Continuar
          </NextButton>
        )}
      </div>
    )
  }

  return (
    <div className={classes.desktop}>
      <div className={classes.desktopContainer}>
        <SafeEnvironment textProps={{ className: classes.text }} />

        <div className={classes.cartAndButton}>
          {!subscribe.sizeCart ? (
            <Typography className={classes.text}>
              Você ainda não possui planos no carrinho
            </Typography>
          ) : (
            <div className={classes.totalFirstInvoice}>
              <Typography className={classes.text}>
                Total da sua primeira fatura
              </Typography>

              <Typography className={classes.price}>
                <Typography component="span" className={classes.pricePrefix}>
                  R$
                </Typography>
                {totalCart}
              </Typography>
            </div>
          )}

          <NextButton
            variant="contained"
            disabled={!subscribe.sizeCart}
            className={classes.nextButton}
            onClick={handleClickNextButton}
            disableElevation
          >
            Continuar
          </NextButton>
        </div>
      </div>
    </div>
  )
}

export default Bottombar
